(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-addon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

  const addon = document.querySelector('[data-product-addon]');

  if (!addon) return;

  const checkbox =
    addon.querySelector('[data-addon-checkbox]');

  const addonVariantId =
    addon.dataset.addonVariantId;

  if (!checkbox || !addonVariantId) return;


  /*
   * Find the Horizon product form
   */

  const productForm =
    addon.closest('product-details')?.querySelector('form[action*="/cart/add"]')
    ||
    document.querySelector('form[action*="/cart/add"]');


  if (!productForm) {

    console.warn(
      'ShopKisu Product Add-on: Product form not found.'
    );

    return;

  }


  /*
   * Store the selected add-on
   */

  productForm.addEventListener('submit', async function (event) {

    if (!checkbox.checked) {
      return;
    }

    event.preventDefault();


    const formData =
      new FormData(productForm);

    const mainVariantId =
      formData.get('id');

    const quantity =
      parseInt(
        formData.get('quantity') || 1,
        10
      );


    if (!mainVariantId) {

      console.error(
        'ShopKisu Product Add-on: Main variant not found.'
      );

      return;

    }


    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            items: [

              {
                id: Number(mainVariantId),
                quantity: quantity
              },

              {
                id: Number(addonVariantId),
                quantity: 1
              }

            ]

          })

        }
      );


      if (!response.ok) {
        throw new Error(
          'Could not add products to cart.'
        );
      }


      /*
       * Redirect to cart
       */

      window.location.href = '/cart';


    } catch (error) {

      console.error(
        'ShopKisu Product Add-on:',
        error
      );

      /*
       * If something fails,
       * submit the normal product form.
       */

      productForm.submit();

    }

  });

});
  } catch(e) { console.error(e); }
})();

})();
